import Box from '@zenbusiness/zui/Box';
import { styled } from '@zenbusiness/zui/styles';

const BoxStyles = ({ theme, isDisable }) => ({
  padding: '24px 16px',
  border: `1px solid ${theme.palette.border.dark}`,
  borderRadius: 16,
  cursor: isDisable ? 'not-allowed' : 'pointer',
  background: isDisable ? theme.palette.background.grey.dark : theme.palette.background.grey.light,
  opacity: isDisable ? 0.7 : 'initial'
});

export const BoxStyled = styled(Box, {
  shouldForwardProp: (prop) => prop !== 'isDisable'
})(BoxStyles);
